import React, { ReactNode, useEffect, useState } from "react";
import { doc, getFirestore, onSnapshot } from "@firebase/firestore";

import FallbackPage from "../FallbackPage/FallbackPage";
import { LoadingCircle } from "@almafintech/react-components";
import Container from "../Container/Container";
import styles from "../FallbackPage/FallbackPage.module.scss";

interface AppStatus {
  maintenance: boolean;
  technicalProblems: boolean;
}

interface MaintenanceScreenProps {
  children: ReactNode;
}
const MaintenanceScreen: React.FC<MaintenanceScreenProps> = ({ children }) => {
  const db = getFirestore();
  const [appStatus, setAppStatus] = useState<AppStatus | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const maintenanceScreenRef = doc(db, "configurations", "maintenanceScreen");

    const unsubscribe = onSnapshot(
      maintenanceScreenRef,
      (doc) => {
        if (doc.exists()) {
          const data = doc.data() as AppStatus;
          setAppStatus(data);
        } else {
          setAppStatus({
            maintenance: false,
            technicalProblems: false,
          });
        }
        setLoading(false);
      },
      (error) => {
        console.error("Firestore onSnapshot error:", error);
        setAppStatus({
          maintenance: false,
          technicalProblems: false,
        });
        setLoading(false);
      }
    );

    return () => {
      return unsubscribe();
    };
  }, []);

  const shouldShowFallback =
    appStatus?.maintenance || appStatus?.technicalProblems;

  // Show loader while loading
  if (loading) {
    return (
      <Container className={styles.container}>
        <LoadingCircle width="50" />
      </Container>
    );
  }

  return shouldShowFallback ? (
    <FallbackPage appStatus={appStatus} />
  ) : (
    <>{children}</>
  );
};

export default MaintenanceScreen;
